import { IAppState } from '../../common/state';
import { IHouse } from '../../types/newbuildingHeader';

export function getHouses({ newbuildingInformation }: IAppState): IHouse[] | null {
  return newbuildingInformation?.houses || null;
}
